import { render, staticRenderFns } from "./tab-course-icons.vue?vue&type=template&id=0aa81e2d&scoped=true&"
import script from "./tab-course-icons.vue?vue&type=script&lang=js&"
export * from "./tab-course-icons.vue?vue&type=script&lang=js&"
import style0 from "./tab-course-icons.vue?vue&type=style&index=0&id=0aa81e2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa81e2d",
  null
  
)

export default component.exports